


































import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import SlidingPanel from '../_sliding-panel/sliding-panel.vue';
import { SidebarState } from '../../store';
import { namespace } from 'vuex-class';
const sidebarState = namespace('SidebarState');

@Component({
    name: "AxWhatsNewPanel",
    components: { SlidingPanel },
})
export default class AxWhatsNewPanel extends Vue {
    @sidebarState.Getter isWhatsNewPanelOpen: boolean;
    @sidebarState.Action closeWhatsNew: () => void;
    @sidebarState.Action toggleWhatsNew: () => void;

    @Ref('WhatsNewPanel') whatsNewPanel: Vue;

    public onClickOutside(e: Event) {
        const targetRefWhatsNewPanel = (this.$refs.AxWhatsNewPanel as Vue).$el as HTMLElement;
        
        const eventTarget = e.target as HTMLElement;
        if (
            !(
                targetRefWhatsNewPanel?.contains(eventTarget) ||
                eventTarget?.shadowRoot?.contains(targetRefWhatsNewPanel)
            )
        ) {
            this.closeWhatsNew();
        }
    };

    public mounted() { window.addEventListener('scroll', this.closeWhatsNew);}
    public unmounted() { window.removeEventListener('scroll', this.closeWhatsNew);}

    public beforeCreate() { SidebarState.register?.(this.$store); }
    public destroyed() { SidebarState.unregister?.(this.$store); }
}
